import { useEffect } from "react";

// Lightweight per-page <head> management for the SPA - titles, descriptions,
// canonical URLs and JSON-LD structured data, no extra dependencies.

const SITE = "https://teardrophydro.co.uk";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function usePageMeta({ title, description, path = "", noindex = false }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      upsertMeta("property", "og:title", title);
      upsertMeta("name", "twitter:title", title);
    }
    if (description) {
      upsertMeta("name", "description", description);
      upsertMeta("property", "og:description", description);
      upsertMeta("name", "twitter:description", description);
    }

    const url = `${SITE}${path}`;
    upsertMeta("property", "og:url", url);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);

    let robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.setAttribute("name", "robots");
        document.head.appendChild(robots);
      }
      robots.setAttribute("content", "noindex,nofollow");
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, path, noindex]);
}

// Inject a JSON-LD structured-data block; replaced on change, removed on unmount.
export function useJsonLd(id, data) {
  const json = data ? JSON.stringify(data) : null;
  useEffect(() => {
    if (!json) return undefined;
    const elId = `ldjson-${id}`;
    document.getElementById(elId)?.remove();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = elId;
    el.text = json;
    document.head.appendChild(el);
    return () => el.remove();
  }, [id, json]);
}

export const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "TearDrop Hydroponics",
  url: SITE,
  image: `${SITE}/images/products/salvoBasil/IMG_4565.JPEG`,
  description:
    "Fresh herbs, salad leaves and microgreens grown hydroponically in Hockley and delivered across Essex within hours of harvest. No pesticides, no food miles.",
  address: {
    "@type": "PostalAddress",
    addressLocality: "Hockley",
    addressRegion: "Essex",
    addressCountry: "GB",
  },
  areaServed: ["Hockley", "Rochford", "Southend-on-Sea", "Essex"],
  priceRange: "££",
};
